interface Props {
  breadcrumbs: { name: string; path: string }[];
  basePath?: string;
  onNavigate: (path: string) => void;
}

export default function Breadcrumbs({ breadcrumbs, basePath = '', onNavigate }: Props) {
  // Determinar el nombre de la raíz según el basePath del usuario
  let rootName = 'Mi unidad';
  let rootPath = '';
  
  if (basePath === '*' || basePath === '') {
    // Usuario con acceso completo: muestra "Mi unidad"
    rootName = 'Mi unidad';
    rootPath = '';
  } else {
    // Usuario con basePath específico: muestra el nombre de su carpeta base
    rootName = basePath.split('/').filter(Boolean).pop() || basePath;
    rootPath = basePath;
  }
  
  return (
    <nav aria-label="breadcrumb" className="mb-0 feebbo-breadcrumb">
      <ol className="breadcrumb mb-0 flex-nowrap" style={{ whiteSpace: 'nowrap', overflowX: 'auto', overflowY: 'hidden', flexWrap: 'nowrap' }}>
        <li className="breadcrumb-item">
          <button
            className="btn btn-link p-0 text-decoration-none fw-semibold"
            style={{ fontSize: '14px', color: 'var(--feebbo-muted)' }}
            onClick={() => onNavigate(rootPath)}
          >
            {rootName}
          </button>
        </li>
        {breadcrumbs.map((crumb, i) => {
          const isLast = i === breadcrumbs.length - 1;
          return (
            <li key={crumb.path} className={`breadcrumb-item${isLast ? ' active' : ''}`} style={{ flexShrink: 0 }}>
              {isLast ? (
                <span className="fw-semibold" style={{ fontSize: '14px', color: 'var(--feebbo-text)' }}>{crumb.name}</span>
              ) : (
                <button
                  className="btn btn-link p-0 text-decoration-none"
                  style={{ fontSize: '14px', color: 'var(--feebbo-muted)' }}
                  onClick={() => onNavigate(crumb.path)}
                >
                  {crumb.name}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
